import React, { useEffect, useState } from 'react'
import prod from "../assets/prod.jpg"
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { SlArrowUp } from "react-icons/sl";
import { SlArrowDown } from "react-icons/sl";
// import { GrDocumentPdf } from "react-icons/gr";
import address from "../assets/address.jpg"
import address1 from "../assets/address1.jpg"
import add from "../assets/add.jpg"
import add1 from "../assets/add1.jpg"
import { FaArrowLeftLong } from "react-icons/fa6";
import Footer from './Footer';
import { Link, useLocation } from 'react-router-dom';
import Navigation from './Navigation';

const Address = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAddressableOpen, setIsAddressableOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);

    const location = useLocation();
    const currentPath = location.pathname;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        if (["/address", "/n3060", "/n765", "/smoke", "/other"].includes(currentPath)) {
            setIsOpen(true);
        }

        if (["/address", "/n3060", "/n765"].includes(currentPath)) {
            setIsAddressableOpen(true);
        }

        if (["/nn100"].includes(currentPath)) {
            setIsOpen1(true);
        }

        if (["/foam", "/foamm"].includes(currentPath)) {
            setIsOpen2(true);
        }
    }, [currentPath]);

    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>
            <div className="relative overflow-hidden">
                <img src={prod} alt="Product" className={`w-full h-auto object-cover transition-transform duration-1000 ${isVisible ? 'scale-100' : 'scale-110'}`}/>
                
                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Products
                    </h1>
                </div>
            </div>

            <div className="w-full px-4 xl:px-20 py-3 xl:py-5 overflow-hidden">
                <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <Link to="/" className="uppercase text-green-700 hover:underline transition-colors duration-300">
                        Home
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <Link to="/products" className="uppercase text-green-700 hover:underline">
                        Products
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <p className="text-gray-800">Addressable Systems</p>
                </div>
            </div>

            <div className="px-2 xl:px-20 py-4 xl:py-6">
                <div className="flex flex-col-reverse lg:flex-row gap-8 items-start justify-start">

                    <div className="w-full lg:w-auto">
                        <div className="py-2">
                            <Link to="/products">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className="text-xl text-gray-900 uppercase group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Products
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Fire Alarm Systems
                                    </h1>
                                    {isOpen ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen && (
                                    <div className="mt-4 bg-white px-4 py-3">
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center py-1 border-b border-gray-300 cursor-pointer" onClick={() => setIsAddressableOpen(!isAddressableOpen)}>
                                                <h1 className="text-lg font-semibold text-gray-800 mb-2 mt-1">
                                                    Addressable Systems
                                                </h1>
                                                {isAddressableOpen ? (
                                                    <SlArrowUp className="text-gray-500 w-4 h-4" />
                                                ) : (
                                                    <SlArrowDown className="text-gray-500 w-4 h-4" />
                                                )}
                                            </div>
                                            {isAddressableOpen && (
                                                <div>
                                                    <Link to="/address">
                                                        <h2 className={`text-md mt-4 mb-3 pl-3 ${currentPath === "/address" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>Addressable Systems TOP</h2>
                                                    </Link>

                                                    <Link to="/n3060">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n3060" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N3060
                                                        </h2>
                                                    </Link>
                                                    <Link to="/n765">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n765" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N765
                                                        </h2>
                                                    </Link>
                                                    <div className="border-b border-gray-300"></div>
                                                </div>
                                            )}

                                            <Link to="/smoke">
                                                <div className="py-1 border-b border-gray-300">
                                                    <h1 className={`text-lg font-semibold mt-1 mb-2 ${currentPath === "/smoke" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Aspirating Smoke Detector (Protecview)
                                                    </h1>
                                                </div>
                                            </Link>
                                            <Link to="/other">
                                                <div className="py-1">
                                                    <h1 className={`text-lg font-semibold mt-1 ${currentPath === "/other" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Common Devices
                                                    </h1>
                                                </div>
                                            </Link>
                                            <Link to="/flame">
                                                <div className="py-1">
                                                    <h1 className={`text-lg font-semibold mt-1 ${currentPath === "/flame" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        IR3 Flame Detectors
                                                    </h1>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen1(!isOpen1)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Nitrogen Gas Fire Suppression Systems
                                    </h1>
                                    {isOpen1 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen1 && (
                                    <div className="mt-4 bg-white px-4 py-4">
                                        <div className="space-y-2">
                                            <Link to="/nn100">
                                                <div className="border-b border-gray-300 pb-3">
                                                    <h2 className={`text-lg font-semibold ${currentPath === "/nn100" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Engineered Type (NN100)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/nn100">
                                                <div className="pb-1 mt-1">
                                                    <h2 className="text-lg font-semibold text-gray-800 hover:text-green-600 mt-2">Package Type</h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen2(!isOpen2)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Foam Extinguishing Systems
                                    </h1>
                                    {isOpen2 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen2 && (
                                    <div className="mt-4 bg-white px-2 xl:px-4 py-2 xl:py-4">
                                        <div className="space-y-2">
                                            <Link to="/foam">
                                                <div className="border-b border-gray-300 pb-2">
                                                    <h2 className={`text-lg font-semibold mb-1 ${currentPath === "/foam" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        High Expansion Foam (Perf-EX)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/foamm">
                                                <div className="pb-1 mt-2">
                                                    <h2 className={`text-lg font-semibold  mt-2 ${currentPath === "/foamm" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Package Type (MIDEX III)
                                                    </h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <Link to="/video">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className={`text-xl flex-1 pr-3 transition-colors duration-300 ${currentPath === "/video" ? "text-green-600" : "text-gray-800 group-hover:text-green-600"}`}>
                                        Product Videos
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {/* Addressable Systems */}
                    <div className="px-2 xl:px-4">

                        <div className="block md:hidden w-fit mb-6">
                            <div className="flex items-center gap-3 bg-gray-200 text-gray-700 text-md font-medium px-6 py-2 shadow-sm">
                                <FaArrowLeftLong className="w-4 h-4" />
                                <Link to="/products" className="hover:underline">
                                    Back to <span className="uppercase">Products</span>
                                </Link>
                            </div>
                        </div>

                        <div className="flex flex-col items-start w-full">
                            <h1 className="text-2xl xl:text-4xl font-semibold">
                                Addressable Systems
                            </h1>
                            <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />

                            {/* <div className="flex items-center justify-between bg-gray-200 border border-gray-200 shadow-sm px-4 py-3 w-full md:w-80 mt-7">
                                <h1 className="text-base font-semibold text-black">
                                    Integrex Multicrest Brochure
                                </h1>
                                <a href="/" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:scale-105 transition flex-shrink-0">
                                    <GrDocumentPdf className="w-7 h-7" />
                                </a>
                            </div> */}
                        </div>

                        <div className="space-y-10">
                            <div className="flex justify-center items-center w-full mt-4">
                                <img src={address} alt="Address" className="h-full max-w-full object-cover" />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pb-14 pt-6">
                                <Link to="/n3060">
                                    <div className="flex flex-col items-center text-center space-y-2 hover:text-green-700">
                                        <img src={address1} alt="N3060" className="w-full h-52 object-cover" />
                                        <h1 className="text-lg">N3060</h1>
                                    </div>
                                </Link>

                                <Link to="/n765">
                                    <div className="flex flex-col items-center text-center space-y-2 hover:text-green-700">
                                        <img src={add} alt="N765" className="w-full h-52 object-cover" />
                                        <h1 className="text-lg">N765</h1>
                                    </div>
                                </Link>

                                <Link to="/other">
                                    <div className="flex flex-col items-center text-center space-y-2 hover:text-green-700">
                                        <img src={add1} alt="Common Devices" className="w-full h-52 object-cover" />
                                        <h1 className="text-lg">Common Devices</h1>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div><Footer /></div>

        </>
    )
}

export default Address